"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTeams = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_query_1 = require("react-query");
const ObjectivesClient_1 = require("client/ObjectivesClient");
const teamsKeys_1 = __importDefault(require("consts/queryKeys/teamsKeys"));
const useGetTeams = (page, params, options) => {
    const fetchTeams = (olderThan) => __awaiter(void 0, void 0, void 0, function* () {
        const queryParams = Object.assign(Object.assign({}, params), (olderThan && { olderThan }));
        return (0, ObjectivesClient_1.getAllTeam)(queryParams);
    });
    return (0, react_query_1.useInfiniteQuery)(teamsKeys_1.default.teams(page, params), ({ pageParam }) => fetchTeams(pageParam), Object.assign({ getNextPageParam: lastPage => {
            var _a, _b;
            return (_b = (_a = lastPage === null || lastPage === void 0 ? void 0 : lastPage.pagination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.olderThan;
        } }, options));
};
exports.useGetTeams = useGetTeams;
